// Scale factor that maps content pixels onto the fixed-width minimap track.
export const getMinimapScale = (
  contentWidth: number,
  minimapWidth: number
): number => (contentWidth > 0 ? minimapWidth / contentWidth : 0);

// Content px -> minimap px.
export const toMinimapPx = (contentPx: number, scale: number): number =>
  contentPx * scale;

// Minimap px -> content px.
export const toContentPx = (minimapPx: number, scale: number): number =>
  scale > 0 ? minimapPx / scale : 0;

interface FrameGrab {
  pointerX: number;
  frameLeft: number;
  frameWidth: number;
}

// Where the pointer "grabs" the viewport frame. Pressing inside the frame keeps
// the exact offset so it does not jump; pressing outside centers the frame on
// the pointer (a scrollbar-style jump).
export const getFrameGrabOffset = ({
  pointerX,
  frameLeft,
  frameWidth,
}: FrameGrab): number =>
  pointerX >= frameLeft && pointerX <= frameLeft + frameWidth
    ? pointerX - frameLeft
    : frameWidth / 2;

// Content scrollLeft for a pointer at `pointerX` (minimap px) holding the frame
// at `grabOffset`.
export const getScrollLeftFromPointer = (
  pointerX: number,
  grabOffset: number,
  scale: number
): number => toContentPx(pointerX - grabOffset, scale);
